// extracted by mini-css-extract-plugin
export default {"reValidateCardSection":"N1-z","paymentSection":"O1-z","disabled":"P1-z","sectionButtons":"Q1-z","usingAmazonPayMsg":"R1-z"};